import { createTheme, type ThemeOptions } from '@mui/material/styles'

// ── Shared settings ─────────────────────────────────────────────────────────

const shared: ThemeOptions = {
  typography: {
    fontFamily: '"Google Sans", "Segoe UI", system-ui, sans-serif',
    h4: { fontWeight: 700 },
    h5: { fontWeight: 700 },
    h6: { fontWeight: 600 },
  },
  shape: { borderRadius: 10 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { textTransform: 'none' as const, fontWeight: 600, borderRadius: 8 },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { fontWeight: 600 },
      },
    },
  },
}

// Google brand palette — shared between both modes
const brand = {
  primary:   { main: '#4285F4', light: '#669DF6', dark: '#1A73E8' },
  secondary: { main: '#34A853' },
  error:     { main: '#EA4335' },
  warning:   { main: '#FBBC04' },
}

// ── Dark theme ──────────────────────────────────────────────────────────────

export const darkTheme = createTheme({
  ...shared,
  palette: {
    mode: 'dark',
    ...brand,
    background: { default: '#0f1117', paper: '#1e293b' },
    text: { primary: '#e2e8f0', secondary: '#94a3b8' },
  },
  components: {
    ...shared.components,
    MuiCard: {
      styleOverrides: {
        root: { backgroundImage: 'none', border: '1px solid rgba(255,255,255,0.08)' },
      },
    },
  },
})

// ── Light theme ─────────────────────────────────────────────────────────────

export const lightTheme = createTheme({
  ...shared,
  palette: {
    mode: 'light',
    ...brand,
    background: { default: '#f5f6fa', paper: '#ffffff' },
    text: { primary: '#1e293b', secondary: '#64748b' },
  },
  components: {
    ...shared.components,
    MuiCard: {
      styleOverrides: {
        root: { backgroundImage: 'none', border: '1px solid rgba(0,0,0,0.08)' },
      },
    },
  },
})

// Keep a default export for backward compat (used nowhere now, but harmless)
export default darkTheme
